module.exports = __webpack_public_path__ + "img/dream_flatline.edc7b788.svg";